import { sva } from '@agapi/ui/panda/css';
import { anatomy } from '@zag-js/accordion';
export const accordionStyles = sva({
    slots: anatomy.keys(),
    base: {
        item: {
            borderBottom: "1px solid",
            borderColor: "borders.base",
        },
        itemTrigger: {
            display: "flex",
            width: "100%",
            height: "50px",
            justifyContent: "space-between",
            alignItems: "center",
            py: "tight",
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: "md",
        },
        itemContent: {
            gap: "tight",
            pb: "tight",
        },
        itemIndicator: {
            transition: "0.21s ease",
            color: "borders.base",
            fontSize: "xl",
            _open: {
                transform: "rotate(-45deg)"
            }
        },
    },
});
